import classNames from 'classnames';
import * as React from 'react';
import { memo } from 'react';

import settings from '~/settings';
import { t } from '~/helpers/localization';

import styles from './ClanTitle.scss';

interface ClanTitleProps {
  title: string | React.ReactNode;
  isOwn: boolean;
}

const ClanTitle = ({ title, isOwn = false }: ClanTitleProps) => {
  const classNameBase = classNames(styles.base, {
    [styles.isNavalBaseEnabled]: settings.supply.isEnabled,
  });

  return (
    <div className={classNameBase}>
      <div className={styles.title}>{title}</div>
      {isOwn && <div className={styles.isOwnClan}>{t('Это ваш клан')}</div>}
    </div>
  );
};

export default memo(ClanTitle);
